import { render, staticRenderFns } from "./addingNewLabelComp.vue?vue&type=template&id=52cd1352&scoped=true&"
import script from "./addingNewLabelComp.vue?vue&type=script&lang=js&"
export * from "./addingNewLabelComp.vue?vue&type=script&lang=js&"
import style0 from "./addingNewLabelComp.vue?vue&type=style&index=0&id=52cd1352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cd1352",
  null
  
)

export default component.exports